@for (j of [].constructor(tdAmount); track $index; let idx = $index) {
  <td>
    <div [ngClass]="blankSpaceIndices.includes(idx) ? ' blank-space' : 'td-empty-state'"></div>
  </td>
}
